export const USER_SUPPORT_LINK = 'mailto:jordan.fox@spacecubed.com'
